import _Object$values2 from "@babel/runtime-corejs3/core-js/object/values";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js/instance/map";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _findInstanceProperty from "@babel/runtime-corejs3/core-js/instance/find";
import { every, isEmpty, pick } from "lodash";
import { denormalize } from "normalizr";
import { calendarsSchema } from "./settings-schema";
import { REQUIRED_FILOGIX_DETAILS_FOR_CREDIT_PULL, REQUIRED_FILOGIX_DETAILS_FOR_IMPORT, REQUIRED_FILOGIX_DETAILS_FOR_SUBMISSION } from "@Broker/@Utils/constants";
export const GET_SYNCED_EMAILS = "GET_SYNCED_EMAILS";
export const GET_IS_ON_THEME_PREVIEW_MODE = "GET_IS_ON_THEME_PREVIEW_MODE";
export const GET_CALENDARS = "GET_CALENDARS";
export const SYNCED_EMAILS_LIST = "SYNCED_EMAILS_LIST";
export const ACCOUNT_HAS_EMAIL_SYNCED = "ACCOUNT_HAS_EMAIL_SYNCED";
export const DEFAULT_SYNCED_ACCOUNT_EMAIL = "DEFAULT_SYNCED_ACCOUNT_EMAIL";
export const GET_FILOGIX_DETAILS = "GET_FILOGIX_DETAILS";
export const IS_EXPERT_PROFILE_NUMBER_VERIFIED = "IS_EXPERT_PROFILE_NUMBER_VERIFIED";
export const MISSING_FILOGIX_DETAILS_FOR_IMPORT = "MISSING_FILOGIX_DETAILS_FOR_IMPORT";
export const MISSING_FILOGIX_DETAILS_FOR_CREDIT_PULL = "MISSING_FILOGIX_DETAILS_FOR_CREDIT_PULL";
export const MISSING_FILOGIX_DETAILS_FOR_SUBMISSION = "MISSING_FILOGIX_DETAILS_FOR_SUBMISSION";
export const GET_CO_BROKERING_OVERRIDES = "GET_CO_BROKERING_OVERRIDES";
const getters = {
  [GET_SYNCED_EMAILS]: state => {
    return state.syncedEmails;
  },
  [SYNCED_EMAILS_LIST]: state => {
    var _Object$values;
    return ((_Object$values = _Object$values2(state.syncedEmails.emails)) == null ? void 0 : _mapInstanceProperty(_Object$values).call(_Object$values, ({
      email
    }) => email)) || [];
  },
  [ACCOUNT_HAS_EMAIL_SYNCED]: (state, getters) => {
    return !isEmpty(getters[SYNCED_EMAILS_LIST]);
  },
  [GET_IS_ON_THEME_PREVIEW_MODE]: state => {
    return state.isOnThemePreviewMode;
  },
  [GET_CALENDARS]: state => accountId => {
    const {
      allIds,
      calendars
    } = state.syncedCalendars;
    const syncedCalendars = denormalize(allIds, [calendarsSchema], {
      calendars: calendars
    });
    return _filterInstanceProperty(syncedCalendars).call(syncedCalendars, calendar => calendar.nylasAccountId == accountId);
  },
  [DEFAULT_SYNCED_ACCOUNT_EMAIL]: state => {
    var _context;
    return _findInstanceProperty(_context = _Object$values2(state.syncedEmails.emails)).call(_context, ({
      defaultAccount
    }) => !!defaultAccount);
  },
  [GET_FILOGIX_DETAILS]: state => {
    return state.filogixDetails;
  },
  [IS_EXPERT_PROFILE_NUMBER_VERIFIED]: state => {
    return state.filogixDetails.verified;
  },
  [MISSING_FILOGIX_DETAILS_FOR_IMPORT]: state => {
    return REQUIRED_FILOGIX_DETAILS_FOR_IMPORT.some(key => !state.filogixDetails[key]);
  },
  [MISSING_FILOGIX_DETAILS_FOR_CREDIT_PULL]: state => {
    const {
      filogixDetails
    } = state;
    if (isEmpty(filogixDetails)) return false;
    return !every(pick(filogixDetails, REQUIRED_FILOGIX_DETAILS_FOR_CREDIT_PULL), Boolean);
  },
  [MISSING_FILOGIX_DETAILS_FOR_SUBMISSION]: state => {
    const {
      filogixDetails
    } = state;
    if (isEmpty(filogixDetails)) return false;
    return !every(pick(filogixDetails, REQUIRED_FILOGIX_DETAILS_FOR_SUBMISSION), Boolean);
  },
  [GET_CO_BROKERING_OVERRIDES]: state => {
    return state.overrides;
  }
};
export default getters;